// import { Injectable } from "@angular/core";
// import Swal from "sweetalert2";

// @Injectable({
//   providedIn: "root",
// })
// export class SweetAlertService {
//   constructor() {}
//   success(message: string, title: string = "Success!") {
//     Swal.fire({
//       title: title,
//       icon: "success",
//       text: message,
//       confirmButtonText: "OK",
//       confirmButtonColor: "#016239",
//       position: "center",
//     });
//   }

//   confirm(message: string, title: string): Promise<any> {
//     return Swal.fire({
//       title,
//       text: message,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonText: "Yes",
//       confirmButtonColor: "#016239",
//       cancelButtonText: "No",
//       cancelButtonColor: "Red",
//     });
//   }

//   error(message: string, title: string = "Error!") {
//     Swal.fire({
//       title: title,
//       icon: "error",
//       text: message,
//       confirmButtonText: "OK",
//       confirmButtonColor: "crimson",
//     });
//   }
// }

import { Injectable } from "@angular/core";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})
export class SweetAlertService {
  constructor() { }

  success(
    message: string,
    title: string = "Success!",
    autoClose: boolean = true,
    timer?: number
  ) {
    Swal.fire({
      title: title,
      icon: "success",
      text: message,
      confirmButtonText: "OK",
      confirmButtonColor: "#016239",
      position: "center",
      timer: autoClose ? (timer ?? 3000) : (timer ?? undefined), // use timer if provided or default ehn false and timer provided use timer else close manually
      timerProgressBar: autoClose, // show progress bar if autoclose
    });
  }

  confirm(message: string, title: string): Promise<any> {
    return Swal.fire({
      title,
      text: message,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ok",
      confirmButtonColor: "var(--daxaColor)",
      cancelButtonText: "Cancel",
      cancelButtonColor: "Red",
    });
  }

  warning(
    message: string,
    title: string = "Warning!",
    autoClose: boolean = false,
  ) {
    Swal.fire({
      title: title,
      icon: "warning",
      text: message,
      confirmButtonText: "OK",
      confirmButtonColor: "orange",
      timer: autoClose ? 3000 : undefined,
      timerProgressBar: autoClose,
    });
  }

  info(message: string, title: string = "Info", autoClose: boolean = false) {
    Swal.fire({
      title: title,
      icon: "info",
      text: message,
      confirmButtonText: "OK",
      confirmButtonColor: "blue",
      timer: autoClose ? 3000 : undefined,
      timerProgressBar: autoClose,
    });
  }

  error(message: string, title: string = "Error!", autoClose: boolean = false) {
    Swal.fire({
      title: title,
      icon: "error",
      text: message,
      confirmButtonText: "OK",
      confirmButtonColor: "crimson",
      timer: autoClose ? 3000 : undefined, // only close automatically if you want
      timerProgressBar: autoClose,
    });
  }
}
